import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import cx from 'classnames';
import $ from 'jquery';
import { wireChecked } from 'ui/hoc/prop-wire';

var log = require('loglevel').getLogger('core/components/checkbox');
/**
 * A React Checkbox
 * @constructor
 * @param {string} [id] - Container dom element #id
 * @param {string} [className] - Classname for the container
 * @param {boolean} [defaultChecked] - Default checked value
 * @param {boolean} [checked] - Current checked value
 * @param {object} [checkedLink] - Link to update check value. Used in conjuction with [linked-state-mixins]{@link module:linked-state-mixins}
 * @param {*} checkedLink.value - value to update
 * @param {function} checkedLink.requestChange - function to request check value change
 * @param {boolean} [disabled=false] - Is checkbox disabled?
 * @param {function} onChange  - Callback function when checkbox is ticked/unticked. <br> Required when value prop is supplied
 * @param {boolean} onChange.checked - checked?
 * @param {object} onChange.eventInfo - event related info
 * @param {boolean} onChange.eventInfo.before - was checked or unchecked?
 *
 * @example
// controlled

import Checkbox from 'core/components/checkbox'
React.createClass({
    getInitialState() {
        return {subscribe:false}
    },
    handleChange(subscribe) {
        this.setState({subscribe})
    },
    render() {
        let {subscribe} = this.state;
        return <div className='c-flex aic'>
            <label htmlFor='subscribe'>Would you like to subscribe to this newsletter?</label>
            <Checkbox id='subscribe'
                onChange={this.handleChange}
                checked={subscribe}/>
        </div>
    }
})
 */


var Checkbox = createReactClass({
  displayName: "Checkbox",
  propTypes: {
    id: PropTypes.string,
    className: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    if (this.props.id && !this.props.disabled) {
      this.getLabelForCheckbox().on('click', function (evt) {
        _this.handleChange(evt);
      });
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.getLabelForCheckbox().off();
  },
  getLabelForCheckbox: function getLabelForCheckbox() {
    return $(this.node).parent().find('label[for="' + this.props.id + '"]');
  },
  handleChange: function handleChange(evt) {
    evt.stopPropagation();
    var _this$props = this.props,
        onChange = _this$props.onChange,
        checked = _this$props.checked;
    onChange(!checked);
  },
  render: function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        id = _this$props2.id,
        className = _this$props2.className,
        checked = _this$props2.checked,
        disabled = _this$props2.disabled;
    return /*#__PURE__*/React.createElement("i", {
      id: id,
      ref: function ref(_ref) {
        _this2.node = _ref;
      },
      onClick: disabled ? null : this.handleChange,
      className: cx('c-checkbox', 'far', 'fa-' + (checked ? 'check-' : '') + 'square', {
        disabled: disabled
      }, className)
    });
  }
});
export default wireChecked(Checkbox);